.popover {
  z-index: 6 !important;
}